{
  "AddCRMTitle": "Add CRM Integration",
  "ModififyCRMTitle": "Modify CRM Integration",
  "CRMDetailsTitle": "Details",
  "CRMGeneralIDLabel": "ID",
  "CRMDetailsIDLabelPlaceholder": "[Auto Assigned]",
  "CRMDetailsDescriptionLabel": "Description",
  "CRMValidationDescriptionLabel": "Description is required",
  "NAME": "CRMModal"
}